import type { Event } from '@patsnap/tahiti-core/common/event';
import type {
    SpecificationConfirmDisclosureData,
    SpecificationConfirmDisclosureState,
    SpecificationConfirmDisclosureDataErrors,
} from '../types/specification-confirm-disclosure';

export const SpecificationConfirmDisclosureService = Symbol.for('SpecificationConfirmDisclosureService');

export interface SpecificationConfirmDisclosureService {
    readonly onStateChange: Event<SpecificationConfirmDisclosureState>;

    /**
     * 初始化, 如果内部状态已准备好, 则直接返回
     * @param taskId 任务ID
     */
    init(taskId: string, regenerate?: boolean): Promise<void>;

    /** 获取状态 */
    getState(): SpecificationConfirmDisclosureState;

    /** 设置表单数据 */
    patchFormData(payload: Partial<SpecificationConfirmDisclosureData>): void;

    /** 校验表单数据 */
    validateFormData(): Promise<SpecificationConfirmDisclosureDataErrors>;

    /** 校验表单数据 */
    validate4formData(formData: SpecificationConfirmDisclosureData): Promise<SpecificationConfirmDisclosureDataErrors>;

    /** 获取表单校验错误信息 */
    getFormErrors(): SpecificationConfirmDisclosureDataErrors;

    /**
     * 提交
     * !!! 默认会切换到下一个步骤
     */
    submit(switchStep?: boolean): Promise<void>;

    /**
     * 重新生成
     * 需要先 cancel 当前任务
     * 然后重新初始化
     */
    regenerate(): Promise<void>;
}
